import { isThousandOperand } from '@unified-checkout/design-system';

const MIN_FLOAT_VALUE = {
  THOUSAND_OPERAND: 0.001,
  STANDARD: 0.01,
};

export const getMinimumValidAmount = (currency: string) => {
  return isThousandOperand(currency)
    ? MIN_FLOAT_VALUE.THOUSAND_OPERAND
    : MIN_FLOAT_VALUE.STANDARD;
};
